import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useDemoteUser = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (userId: string) => {
      const response = await fetchWithAuth(`${URL}/roles/demote/${userId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      })
      return response
    },
    onSuccess: (data, userId) => {
      // Invalidate the specific user query
      queryClient.invalidateQueries({ queryKey: ['adminUser', userId] })
      // Invalidate the admin users list
      queryClient.invalidateQueries({ queryKey: ['adminUsers'] })
      // Invalidate user by profile ID queries (for profile detail view)
      queryClient.invalidateQueries({ queryKey: ['userByProfileId'] })
    },
  })
}

export const usePromoteUser = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (userId: string) => {
      const response = await fetchWithAuth(`${URL}/roles/promote/${userId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      })
      return response
    },
    onSuccess: (data, userId) => {
      // Invalidate the specific user query
      queryClient.invalidateQueries({ queryKey: ['adminUser', userId] })
      // Invalidate the admin users list
      queryClient.invalidateQueries({ queryKey: ['adminUsers'] })
      // Invalidate user by profile ID queries (for profile detail view)
      queryClient.invalidateQueries({ queryKey: ['userByProfileId'] })
    },
  })
}
